export default __webpack_public_path__ + "static/media/82.b53c424e.jpg";